import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as authActions from 'global/actions/authActions';
import { useActions } from 'hooks/useActions';
import { Modal } from 'components/Modals/modalElements';
import ModalContentSignUp from './ModalContentSignUp';
import ModalContentSignIn from './ModalContentSignIn';
import ModalContentResetPassword from './ModalContentResetPassword';
import ModalContentConvertUser from './ModalContentConvertUser';
import ModalContentTwoFactor from './ModalContentTwoFactor';

const english = 'en';

const view = {
  signIn: 'signIn',
  signUp: 'signUp',
  resetPassword: 'resetPassword',
  convertUser: 'convertUser',
};

const getInitialView = (user, isTicketAuth) => {
  if (!user?._id) return view.signUp;
  if (user.email && user.hasPassword && isTicketAuth) return view.signIn;
  return view.convertUser;
};

// Auth modal intended for use in the freecode editor
export default function FreecodeAuthModal({ onCancel, isOpen = true }) {
  const { user, isTicketAuth, isCommunityUser, authError, authTwoFactor } = useSelector((state) => state.auth);
  const { clearAuthError } = useActions(authActions);

  const [currentView, setCurrentView] = useState(getInitialView(user, isTicketAuth));
  const [email, setEmail] = useState(user?.email || '');

  useEffect(() => {
    if (authError) {
      toast.error(authError?.[english] || authError);
      clearAuthError();
    }
  }, [authError, clearAuthError]);

  useEffect(() => {
    if (user?.hasPassword && !isTicketAuth && !isCommunityUser) setCurrentView(view.convertUser);
  }, [user, isTicketAuth, isCommunityUser, setCurrentView]);

  const signUpModalBody = () => (
    <ModalContentSignUp
      onCancel={onCancel}
      goToLogin={() => setCurrentView(view.signIn)}
      email={email}
      setEmail={setEmail}
    />
  );

  const signInModalBody = () => (
    <ModalContentSignIn
      onCancel={onCancel}
      goToSignUp={() => setCurrentView(view.signUp)}
      goToResetPassword={() => setCurrentView(view.resetPassword)}
      email={email}
      setEmail={setEmail}
    />
  );

  const resetPasswordModalBody = () => (
    <ModalContentResetPassword
      onCancel={onCancel}
      goToLogin={() => setCurrentView(view.signIn)}
      email={email}
      setEmail={setEmail}
    />
  );

  const twoFactorModalBody = () => <ModalContentTwoFactor onCancel={onCancel} />;

  const covertUserModalBody = () => <ModalContentConvertUser onCancel={onCancel} />;

  const getView = () => (
    <>
      {currentView === view.signUp && signUpModalBody()}
      {currentView === view.signIn && signInModalBody()}
      {currentView === view.resetPassword && resetPasswordModalBody()}
      {currentView === view.convertUser && covertUserModalBody()}
    </>
  );

  return <Modal isOpen={isOpen}>{authTwoFactor ? twoFactorModalBody() : getView()}</Modal>;
}
